export default __webpack_public_path__ + "static/bank-statement-insights-a812794951e8f21609021718eae0738f.webp";